import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import RegistrationService from "../../services/RegistrationService";
import {
  configurationRequest,
  configurationSuccess,
  configurationFail,
  registrationRequest,
  registrationSuccess,
  registrationFail,
  verifyEmailRequest,
  verifyEmailSuccess,
  verifyEmailFail,
} from "../slices/registrationSlice";

/**
 * Fetch registration configuration saga
 * @param {Object} action - Redux action with payload
 */
function* fetchConfiguration(action) {
  try {
    const ajax = yield call(RegistrationService.getRegistrationConfiguration);
    if (ajax.status === 200) {
      yield put(configurationSuccess(ajax.data));
    } else {
      yield put(
        configurationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      configurationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

/**
 * Register user saga
 * @param {Object} action - Redux action with user data payload
 */
function* registerUser(action) {
  try {
    const ajax = yield call(RegistrationService.registerUser, action.payload);
    if (ajax.status === 200 || ajax.status === 201) {
      yield put(registrationSuccess(ajax.data));
    } else {
      yield put(
        registrationFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      registrationFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

/**
 * Verify email saga
 * @param {Object} action - Redux action with token and params payload
 */
function* verifyEmail(action) {
  try {
    const ajax = yield call(RegistrationService.verifyEmail, action.payload);
    if (ajax.status === 200) {
      yield put(verifyEmailSuccess(ajax.data));
    } else {
      yield put(
        verifyEmailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      verifyEmailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

/**
 * Registration saga watcher
 */
function* registrationSaga() {
  yield all([
    takeLatest(configurationRequest.type, fetchConfiguration),
    takeLatest(registrationRequest.type, registerUser),
    takeLatest(verifyEmailRequest.type, verifyEmail),
  ]);
}

export default registrationSaga;
